<template>
	<li class="hoverBg">
		<div class="pic picList">
			<a href="#"><img :src="itemData.coverUrl?itemData.coverUrl:'./static/img/4.jpg'" style="height:250px" alt="" /></a>
		</div>
		<div class="homeCont">
			<h3>{{itemData.title}}</h3>
			<p  class="course_p">
				<!-- <el-rate v-model="value" disabled show-score text-color="#ff9900" score-template="{value}"></el-rate> -->
				<span class="num">{{itemData.studentCount || 0}}人学过</span></p>
		</div>
	</li>
</template>

<script>
/**
 * 描述
 * @description 描述
 * @property {String}
 * @example <aby-botton-line  />
 */

export default {
	props: {
				itemData:[Object]
	},
	data() {
		return {
			value: 3.7
		};
	},
	computed: {},
	created(obj) {
		// 页面第一次加载执行，参数为上个页面传递的数据，参数类型为Object
	},
	methods: {},
	watch: {
		obj: {
			//监听的对象
			deep: true, //深度监听设置为 true
			handler: function(newV, oldV) {
				console.log('watch中：', newV);
			}
		}
	}
};
</script>

<style scoped>
.course_p{ display: block; text-align: right; width: 100%;justify-content: flex-end }
</style>
